<template>
  <!--S 首页 -->
  <section class="wraper">
    <!--S banner -->
    <div class="banner">
      <el-carousel indicator-position >
        <el-carousel-item 
          v-for="(item,index) of shuffling"
          :key="index">
          <a :href="item.shufflingHyperlinked">
          <div class="banner-item"
            :style="{'background': `url(${$base.urlImage}${item.shufflingUrl})`,'background-size':'100% 100%'}"
          >
          </div>
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="container">
      <div class="section-one">
        <h3 class="title">
          <span>我们的产品/Our product</span>
        </h3>
        <p class="title-sub">科学，创新进取，专业高效，诚信服务</p>
        <ul class="tab">
          <li
            class="tab-list"
            v-for="(item,index) of classification" 
            :key="index"
            :style="{'background': `url(${$base.urlImage}${item.classificationUrl})`, 'background-size':'232px 164px', 'background-repeat': 'no-repeat'}"
            :alt="item.alt"
            @click="handleLink(item.classificationHyperlinked)"
          >
          <div class="msg">
            <p class="hd">{{item.classificationName}}</p>
          </div>
          </li>
        </ul>
        <div class="carousel">
          <el-carousel indicator-position>
            <el-carousel-item
            v-for="(item,index) of secondShuffling"
          :key="index"
            >
              <div
              class="carousel-item"
              :style="`background: url(${$base.urlImage}${item.secondShufflingUrl});background-size:cover;`"
              @click="handleLink(item.secondShufflingHyperlinked)">
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="section-two">
        <h3 class="title">
          <span>关于我们/ABOUTUS</span>
        </h3> 
        <p class="title-sub">科学，创新进取，专业高效，诚信服务</p>
        <ul class="tab-two">
          <li
            class="tab-list"
            v-for="(item,index) of link"
            :key="index"
            :style="{'background': `url(${$base.urlImage}${item.linkUrl})`, 'background-size':'cover'}"
            :alt="item.alt"
          >
            <div class="msg">{{item.linkName}}</div>
            <div class="cont">
              <p class="hd">最实惠的价格，最专业的服务做最好的服务企业!</p>
              <p class="bd">BRAND IMAGE PROMOTION</p>
              <a class="more" :href="item.linkHyperlinked">了解更多</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--E content -->
  </section>
</template>

<script>
import { post, get } from "@/axios/index";
export default {
  data() {
    return {
      selectIndex: '',
      isShow: false,
      shuffling:[],
      classification:[],
      secondShuffling:[],
      link:[]
    };
  },
  methods: {
    // 超链接跳转
    handleLink(link) {
      if (link) {
        window.location.href = link
      }
    },
    //跳转产品详情页
    Jump(id) {
      let goodsId = id;
      // 跳转
      this.$router.push({
        path: "/pc/product-detail",
        query: {
          id: goodsId
        }
      });
    },
    select(index) {
      this.selectIndex = index;
    },
  },
  mounted() {
    //获取首页轮播图一
    get("/stkhomepage/getlistbyshufflingtype", {}).then(
      res => {
        this.shuffling=res.data.result;
      },
      err => {
        console.log(err);
        this.$message({
          type: "error",
          message: "error"
        });
      }
    );
    //查询首页分类图
    get("/stkhomepage/getlistbyclassificationtype", {}).then(
      res => {
        this.classification=res.data.result;
         console.log(res);
      },
      err => {
        console.log(err);
        this.$message({
          type: "error",
          message: "error"
        });
      }
    );
    //查询首页轮播图二
    get("/stkhomepage/getlistbysecondshufflingtype", {}).then(
      res => {
        this.secondShuffling=res.data.result;
        console.log('151==this.secondShuffling',this.secondShuffling)
      },
      err => {
        console.log(err);
        this.$message({
          type: "error",
          message: "error"
        });
      }
    );
    //查询首页链接图
    get("/stkhomepage/getlistbylinktype", {}).then(
      response => {
        this.link = response.data.result;
      },
      err => {
        console.log(err);
        this.$message({
          type: "error",
          message: "error"
        });
      }
    );

  }
};
</script>

<style lang="less" scoped>
.wraper {
  width: 100%;
  height: auto;
  overflow: hidden;
  .banner {
    width: 100%;
    height: 600px;
    overflow: hidden;
    /deep/.el-carousel {
      height: 100%;
      .el-carousel__container {
        height: inherit;
      }
    }
    /deep/.el-carousel__indicator button {
      background-color: #999999;
    }
    /deep/.is-active button {
      background-color: #2ba0fe !important;
    }
    .banner-item {
      display: block;
      width: 100%;
      height: 100%;
      background: #666666;
      background-size: cover;
      position: relative;
      .banner-panel {
        width: 504px;
        height: auto;
        position: absolute;
        right: 134px;
        top: 164px;
        text-align: center;
        .banner-tit {
          width: 100%;
          height: 88px;
          font-family: Helvetica-Bold;
          font-size: 41px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 42px;
          letter-spacing: 2px;
          color: #333333;
        }
        .company-name {
          width: 100%;
          height: 24px;
          font-family: NotoSansHans-Medium;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 48px;
          letter-spacing: 2px;
          color: #333333;
          margin-top: 34px;
        }
        .company-subname {
          width: 100%;
          height: 17px;
          font-family: Helvetica-Light;
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 48px;
          letter-spacing: 6px;
          color: #333333;
          margin-top: 15px;
        }
        .more {
          display: block;
          width: 159px;
          height: 41px;
          line-height: 41px;
          background-color: #2ba0fe;
          border-radius: 8px;
          margin: 54px auto 0;
          font-size: 18px;
          letter-spacing: 4px;
          color: #ffffff;
          cursor: pointer;
          font-family: STHeitiSC-Light;
        }
      }
    }
  }
  .container {
    width: 1060px;
    height: auto;
    margin: 0 auto;
    overflow: hidden;
    .title {
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      position: relative;
      margin-top: 50px;
      &::before {
        content: "";
        width: 100%;
        height: 2px;
        background-color: #e6e6e8;
        position: absolute;
        left: 0;
        top: 50%;
      }
      span {
        font-family: AdobeHeitiStd-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 2px;
        color: #4a4a4a;
        display: inline-block;
        padding: 0 33px;
        background-color: #fcfcfc;
        position: relative;
        &:before {
          content: "";
          width: 2px;
          height: 7px;
          display: inline-block;
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -2px;
          background-color: #1892ff;
        }
        &:after {
          content: "";
          width: 2px;
          height: 7px;
          display: inline-block;
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -2px;
          background-color: #1892ff;
        }
      }
    }
    .title-sub {
      width: 100%;
      text-align: center;
      font-family: SimSun;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2px;
      color: #a39f9f;
      margin-top: 11px;
    }
    .section-one {
      width: 100%;
      height: auto;
      overflow: hidden;
      .tab {
        width: 1000px;
        margin: 36px auto 0;
        display: flex;
        justify-content: space-around;
        .tab-list {
          width: 232px;
          height: 250px;
          display: flex;
          cursor: pointer;
          &:hover .msg {
            background-color: #2ba0fe;
            color: #ffffff;
            .hd {
              color: #ffffff;
            }
          }
          .msg {
            width: 232px;
            height: 84px;
            font-family: AdobeHeitiStd-Regular;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 22px;
            letter-spacing: 0px;
            color: #333333;
            align-self: flex-end;
            background-color: #009aff;
            box-sizing: border-box;
            padding: 12px 19px;
            .hd {
              color: #ffffff;
              letter-spacing: 1px;
              font-size: 16px;
              font-weight: 800;
            }
          }
        }
      }
      .carousel {
        width: 1000px;
        height: 480px;
        margin: 50px auto 0;
        /deep/.el-carousel {
          height: 100%;
          .el-carousel__container {
            height: inherit;
          }
        }
        /deep/.el-carousel__indicator button {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #ffffff;
          opacity: 1;
        }
        /deep/.is-active button {
          background-color: #2ba0fe !important;
        }
        .carousel-item {
          width: 100%;
          height: 100%;
          background: url('../../assets/images/index/carousel_one.png') left center no-repeat;
          background-size: cover;
        }
      }
    }
    .section-two {
      .tab-two {
        width: 1000px;
        height: 224px;
        margin: 35px auto 15px;
        display: flex;
        justify-content: space-around;
        .tab-list {
          width: 224px;
          height: 100%;
          position: relative;
          overflow: hidden;
          &:hover .cont {
            top: 0;
            left: 0;
            .hd {
              transform: translateX(0px);
            }
            .bd {
              transform: translateX(0px);
            }
            .more {
              transform: translateY(0);
            }
          }
          .msg {
            width: 100%;
            height: 36px;
            background-color: #000000;
            opacity: .8;
            line-height: 36px;
            position: absolute;
            bottom: 0;
            left: 0;
            text-align: center;
            font-family: MicrosoftYaHei-Bold;
            font-size: 10px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #ffffff;
          }
          .cont {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 224px;
            transition: .4s;
            background-color: #2ba0fe;
            font-family: AdobeHeitiStd-Regular;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 0px;
            color: #ffffff;
            box-sizing: border-box;
            padding: 46px 22px;
            .hd {
              transform: translateX(200px);
              transition: .5s;
              transition-delay: .5s;
            }
            .bd {
              transform: translateX(-200px);
              transition: .5s;
              transition-delay: .5s;
            }
            .more {
              display: inline-block;
              margin-top: 28px;
              width: 99px;
              height: 30px;
              text-align: center;
              line-height: 30px;
              background-color: #2ba0fe;
              border-radius: 5px;
              border: solid 1px #ffffff;
              color: #ffffff;
              letter-spacing: 1px;
              font-family: MicrosoftYaHei-Bold;
              cursor: pointer;
              transform: translateY(100px);
              transition: .5s;
              transition-delay: .5s;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/index.vue